export const LIST_MASONRY_PAGINATION_LOAD_LIMIT = 20
export const LIST_MASONRY_PAGINATION_BUTTON_GAP = 8
export const LIST_MASONRY_PAGINATION_BUTTON_GAP_MOBILE = 4
export const LIST_MASONRY_PAGINATION_BUTTON_SIZE = 36
export const LIST_MASONRY_PAGINATION_BUTTON_SIZE_MOBILE = 28
